// Angular
import { Component, ViewChild, ViewContainerRef } from '@angular/core';

// Formly
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-card',
    templateUrl: './card.wrapper.component.html',
    styleUrls: ['./card.wrapper.component.scss'],
})
export class CardWrapperComponent extends FieldWrapper {
    @ViewChild('fieldComponent', { static: true, read: ViewContainerRef }) fieldComponent: ViewContainerRef;
}
